import { useAuthPhone, useAuthPhoneCheck } from "@/api/phoneNumber";
import { useMessage } from "@/app/messageContext";
import { validatePhoneNumber } from "@/utils/validate-phone-number";
import { useCallback, useEffect, useState } from "react";
import { ModalType, ScreenId, validateCode } from "./login-modal";
import { usePostPhone, usePostPhoneCheck } from "@/api/user";

export const usePhoneAuth = ({
  setIsOpen,
  onLogin,
  initScreen,
  type,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onLogin: () => void;
  initScreen: ScreenId;
  type?: ModalType;
}) => {
  const { mutate: sendPhone, data } = useAuthPhone(() => {
    setScreenId("codeInput");
  });
  const { mutate: sendPhoneCheck } = useAuthPhoneCheck(
    () => {
      onLogin();
      setScreenId(initScreen);
      setTimeLeft(null);
      setCode("");
      setIsOpen(false);
      setCodeError(false);
    },
    () => {
      setCodeError(true);
    },
  );
  const { mutate: sendUserPhone } = usePostPhone(() => {
    setScreenId("codeInput");
  });
  const { mutate: sendUserPhoneCheck } = usePostPhoneCheck(
    () => {
      onLogin();
      setScreenId(initScreen);
      setTimeLeft(null);
      setCode("");
      setIsOpen(false);
      setCodeError(false);
    },
    () => {
      setCodeError(true);
    },
  );
  const [screenId, setScreenId] = useState<ScreenId>(initScreen);
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);
  const messageApi = useMessage();

  useEffect(() => {
    if (!data?.timeout) return;

    setTimeLeft(data.timeout);

    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev && prev > 0 ? prev - 1000 : null));
    }, 1000);

    return () => clearInterval(interval);
  }, [data?.timeout]);

  const handlePhoneSubmit = useCallback(() => {
    if (!validatePhoneNumber("7" + phoneNumber)) {
      messageApi.open({
        type: "error",
        content: "Неправильный формат номера телефона",
      });
      return;
    }
    if (type == "login") {
      sendPhone({ phone: "7" + phoneNumber });
    } else {
      sendUserPhone({ phone: "7" + phoneNumber });
    }
  }, [phoneNumber, sendPhone, messageApi, sendUserPhone, type]);

  const handleCodeSubmit = useCallback(() => {
    if (!validatePhoneNumber("7" + phoneNumber)) {
      setCodeError(true);
      messageApi.open({
        type: "error",
        content: "Неправильный формат номера телефона",
      });
      return;
    }
    if (!validateCode(code)) {
      setCodeError(true);
      messageApi.open({ type: "error", content: "Неправильный формат кода" });
      return;
    }
    if (type === "login") {
      sendPhoneCheck({ phone: "7" + phoneNumber, code });
    } else {
      sendUserPhoneCheck({ phone: "7" + phoneNumber, code });
    }
  }, [phoneNumber, code, sendPhoneCheck, messageApi, sendUserPhoneCheck, type]);

  return {
    screenId,
    timeLeft,
    phoneNumber,
    code,
    setScreenId,
    setPhoneNumber,
    setCode,
    handlePhoneSubmit,
    handleCodeSubmit,
    codeError,
  };
};
